import PageContainer from '@/common/components/PageContainer'
import DynamicSectionListing from '@/modules/client-setting/components/DynamicSection/components/DynamicSectionListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryGetDynamicSection from '@/modules/client-setting/api/hooks/useQueryGetDynamicSection'
import { useTablePagination } from '@/common/hooks/useTablePaginate'

function DynamicSectionPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		skip: (currentPage - 1) * pageSize,
		take: pageSize,
		name: searchQuery,
	}

	const { data, isLoading } = useQueryGetDynamicSection(payload)

	return (
		<PageContainer>
			<DynamicSectionListing
				data={data?.data || []}
				isLoading={isLoading}
				total={data?.total || 0}
			/>
		</PageContainer>
	)
}

const GuardedDynamicSectionPage = withUserPermission(DynamicSectionPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedDynamicSectionPage
